import { render } from "./haircolorDiagResult.vue?vue&type=template&id=068dd079"
import script from "./haircolorDiagResult.vue?vue&type=script&lang=js"
export * from "./haircolorDiagResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__